import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomSheet from "../components/BottomSheet.js";
import ConfirmModal from "../components/ConfirmModal";

export default function MyPage({ user, credits, onLogout }) {
  const navigate = useNavigate();
  const provider = user?.app_metadata?.provider;
  const providerLabel = provider === 'google' ? '구글로 로그인했습니다'
    : provider === 'kakao' ? '카카오로 로그인했습니다'
    : '로그인됨';
  const [sheetOpen, setSheetOpen] = useState(false);
  const [sheetTab, setSheetTab] = useState('company');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    onLogout();
    navigate('/');
  };

  const handleDeleteAccount = async () => {
  setShowDeleteConfirm(true);
};

const handleConfirmDelete = async () => {
  setShowDeleteConfirm(false);
  try {
    const { error } = await supabase.rpc('delete_user');
    if (error) throw error;
    await supabase.auth.signOut();
    onLogout();
    navigate('/');
  } catch (e) {
    alert('탈퇴 처리 중 오류가 발생했어요. 다시 시도해주세요.');
  }
};

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#f0f0f0', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>

        <Header variant="my" />

        <div style={{ padding: '0 16px', display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>

          <div style={{ background: '#ffffff', borderRadius: 12, border: '1px solid #111111', overflow: 'hidden' }}>
            <div style={{ padding: '14px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid #eeeeee' }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#111111', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, flexShrink: 0 }}>
                {user?.email?.[0]?.toUpperCase() ?? '?'}
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>{providerLabel}</div>
                <div style={{ fontSize: 15, color: '#888888', marginTop: 2 }}>{user?.email ?? ''}</div>
              </div>
            </div>
            <div style={{ padding: '14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: 15, color: '#888888', marginBottom: 3 }}>남은 말풍선</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>💬 {credits ?? '...'}개</div>
              </div>
              <button onClick={() => navigate('/payment')}
                style={{ background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 15, fontWeight: 400, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
                충전하기
              </button>
            </div>
          </div>

          <div style={{ background: '#ffffff', borderRadius: 12, border: '1px solid #111111', overflow: 'hidden' }}>
            <div style={{ background: '#111111', color: '#ffffff', padding: '10px 14px', fontSize: 16, fontWeight: 700, letterSpacing: 1, textAlign: 'center' }}>내 정보</div>
            {[['보관함', '/archive'], ['결제내역', '/payment/history']].map(([label, path], i) => (
              <div key={i} onClick={() => path ? navigate(path) : alert('준비중이에요.')}
                style={{ padding: '13px 16px', borderBottom: i === 0 ? '1px solid #eeeeee' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                <span style={{ fontSize: 15, color: '#111111' }}>{label}</span>
                <span style={{ color: '#bbbbbb' }}>→</span>
              </div>
            ))}
          </div>

          <div style={{ background: '#ffffff', borderRadius: 12, border: '1px solid #111111', overflow: 'hidden' }}>
            <div style={{ background: '#111111', color: '#ffffff', padding: '10px 14px', fontSize: 16, fontWeight: 700, letterSpacing: 1, textAlign: 'center' }}>문의하기</div>
            {[  
              { label: '오류 문의', sub: '오류가 발생했나요?', icon: '⚠️', path: '/inquiry/error' },
              { label: '피드백 보내기', sub: '추가 하시고 싶은 말투가 있나요?', icon: '💬', path: '/inquiry/feedback' },
              { label: '리뷰 남기기', sub: '소중한 후기를 남겨주세요', icon: '⭐', path: '/inquiry/review' },
              { label: '환불 요청', sub: '말풍선 환불을 원하시나요?', icon: '↩️', path: '/inquiry/refund' },
            ].map((item, i, arr) => (
              <div key={i} onClick={() => navigate(item.path)}
                style={{ padding: '13px 16px', borderBottom: i < arr.length - 1 ? '1px solid #eeeeee' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 16, width: 20, textAlign: 'center' }}>{item.icon}</span>
                  <div>
                    <div style={{ fontSize: 15, color: '#111111' }}>{item.label}</div>
                    <div style={{ fontSize: 15, color: '#555555', marginTop: 2 }}>{item.sub}</div>
                  </div>
                </div>
                <span style={{ color: '#bbbbbb' }}>→</span>
              </div>
            ))}
          </div>

          <div style={{ background: '#f5f5f5', borderRadius: 12, border: '1px solid #e0e0e0', overflow: 'hidden' }}>
            <div onClick={handleLogout} style={{ padding: '13px 16px', borderBottom: '1px solid #e0e0e0', cursor: 'pointer' }}>
              <span style={{ fontSize: 15, color: '#111111' }}>로그아웃</span>
            </div>
            <div onClick={handleDeleteAccount} style={{ padding: '13px 16px', cursor: 'pointer' }}>
              <span style={{ fontSize: 15, color: '#555555' }}>회원탈퇴</span>
            </div>
          </div>

        </div>

        <Footer onOpenSheet={(tab) => { setSheetTab(tab); setSheetOpen(true); }} />

      </div>

      {sheetOpen && (
        <BottomSheet
          sheetTab={sheetTab}
          setSheetTab={setSheetTab}
          onClose={() => setSheetOpen(false)}
        />
      )}

      {showDeleteConfirm && (
  <ConfirmModal
    type="delete"
    onConfirm={handleConfirmDelete}
    onCancel={() => setShowDeleteConfirm(false)}
  />
)}
    </div>
    
  );
}